import { Suspense, lazy } from 'react'

import Spinner from 'src/components/common/spinner'

import ErrorBoundary from './errorboundary'

const View = lazy(() => import('./view'))

const ViewReportArtifactContainer = (props) => (
    <Suspense fallback={<Spinner />}>
        <ErrorBoundary>
            <View {...props} />
        </ErrorBoundary>
    </Suspense>
)

export default ViewReportArtifactContainer
